'use client'

import * as React from 'react'
import * as AccordionPrimitive from '@radix-ui/react-accordion'

import { PlusIcon } from '~shared/icons/plus-icon'
import { cn } from '../utils/cn'
import { Shevron } from '~shared/icons/shevron'

/*
<Accordion
    type='multiple'
    className='grid grid-cols-2 gap-4'
    defaultValue={['default']}>
    <AccordionItem value='include' className='bg-[#F2F2F2]'>
      <AccordionHeader>
        <AccordionTrigger>
          Триггер
          <AccordionIndicator />
        </AccordionTrigger>
      </AccordionHeader>

      <AccordionContent>
        Купить в Московский Институт Технологий и Управления могут абитуриенты
        из любой страны. Подробнее о правилах приёма иностранных граждан можно
        узнать, обратившись за консультацией к сотрудникам приёмной комиссии
      </AccordionContent>
    </AccordionItem>
    <AccordionItem value='include2' className='bg-[#F2F2F2]'>
      <AccordionHeader>
        <AccordionTrigger>
          MEME
          <AccordionIndicator />
        </AccordionTrigger>
      </AccordionHeader>

      <AccordionContent>CONTENT</AccordionContent>
    </AccordionItem>
    <AccordionItem value='include3' className='bg-[#F2F2F2]'>
      <AccordionHeader>
        <AccordionTrigger>
          MEME
          <AccordionIndicator />
        </AccordionTrigger>
      </AccordionHeader>

      <AccordionContent>CONTENT</AccordionContent>
    </AccordionItem>
  </Accordion>
*/

const Accordion = ({
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Root>) => {
  return (
    <AccordionPrimitive.Root
      data-slot='accordion'
      className='rounded-[24px] p-4'
      {...props}
    />
  )
}

const AccordionItem = ({
  className,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) => {
  return (
    <AccordionPrimitive.Item
      data-slot='accordion-item'
      className={cn('rounded-[24px]', className)}
      {...props}
    />
  )
}

const AccordionHeader = ({
  children,
  className,
  ...rest
}: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Header>) => {
  return (
    <AccordionPrimitive.Header
      className={cn('flex cursor-pointer font-medium text-md', className)}
      {...rest}>
      {children}
    </AccordionPrimitive.Header>
  )
}

const AccordionIndicator = ({
  className,
  ...rest
}: React.ComponentPropsWithRef<'div'>) => {
  return (
    <div
      data-slot='accordion-indicator'
      className={cn(
        'flex-shrink-0 transition-all duration-300 group-data-[state=open]:rotate-45 bg-tertiary',
        'group-hover:bg-accent text-lg text-primary size-[50px] rounded-full flex items-center justify-center',
        className
      )}
      {...rest}>
      <PlusIcon />
    </div>
  )
}
const AccordionIndicator2 = ({
  className,
  ...rest
}: React.ComponentPropsWithRef<'span'>) => {
  return (
    <span
      data-slot='accordion-indicator'
      className={cn(
        'flex-shrink-0 transition-all rotate-90 duration-300 group-data-[state=open]:rotate-[270deg] ',
        ' text-lg text-black flex items-center justify-center',
        className
      )}
      {...rest}>
      <Shevron size='lg' />
    </span>
  )
}

const AccordionTrigger = ({
  children,
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>) => {
  return (
    <AccordionPrimitive.Trigger
      data-slot='accordion-trigger'
      className={cn(
        'group p-4 pl-6 flex flex-1 items-center justify-between font-medium text-start',
        'transition-all duration-300 hover:text-accent',
        className
      )}
      {...props}>
      {children}
    </AccordionPrimitive.Trigger>
  )
}

const AccordionContent = ({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Content>) => {
  return (
    <AccordionPrimitive.Content
      data-slot='accordion-content'
      className='font-medium text-[#00000080] data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-[14px] leading-[1] tracking-[-0.01em]'
      {...props}>
      <div className={cn('p-6 pt-0', className)}>{children}</div>
    </AccordionPrimitive.Content>
  )
}

AccordionContent.displayName = AccordionPrimitive.Content.displayName

export {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionIndicator,
  AccordionIndicator2,
  AccordionItem,
  AccordionTrigger
}
